'use client';

import { RouteErrorFallback } from '../components/ErrorFallback';

// Shown in place of the root layout, so it brings its own document.
export default function GlobalError({ error, retry }: { error: Error; retry: () => void }) {
  return (
    <html lang="en">
      <body>
        <RouteErrorFallback error={error} retry={retry} />
      </body>
    </html>
  );
}
